// extracted by mini-css-extract-plugin
export default {"root":"AspectRatioWrapper_root__4X-AC","aspectPadding":"AspectRatioWrapper_aspectPadding__4Yy-O","aspectBox":"AspectRatioWrapper_aspectBox__Q6vae"};